// Suomalainen mobile phone number, including old formats that can have shorter mobile numbers

export const mobilePhoneNumberIncludingOldFormatsFI = input => {
    if (!input) {
        return true;
    }

    const trimmedValue = input.replace(/[ ()+-]/g, '');

    // must start with 04x, 0457 or 050 (leading '0' is optional)
    return /^0?4[0-9]{5,8}$|^0?457[0-9]{4,7}$|^0?50[0-9]{4,7}$/.test(trimmedValue);
};

export default mobilePhoneNumberIncludingOldFormatsFI;
